module.exports = __webpack_public_path__ + "img/Type=EN, Color=Navy.569c2fe7.svg";